/* tslint:disable */
/* eslint-disable */
/**
 * Eatgrim Shipping API
 * Eatgrim Shipping API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: tech@soundsgood.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { TimeEntryFromJSON, TimeEntryToJSON, } from './';
export function DateSlotFromJSON(json) {
    return DateSlotFromJSONTyped(json, false);
}
export function DateSlotFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'date': !exists(json, 'date') ? undefined : (new Date(json['date'])),
        'timeEntries': (json['timeEntries'].map(TimeEntryFromJSON)),
    };
}
export function DateSlotToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'date': value.date === undefined ? undefined : (value.date.toISOString().substr(0, 10)),
        'timeEntries': (value.timeEntries.map(TimeEntryToJSON)),
    };
}
